import { Modal, ModalBody, ModalHeader } from "flowbite-react";
import { BaremeSummary } from "@/features/sponsorship/components/reglement/BaremeSummary";
import { SponsorshipTermsContent } from "@/features/sponsorship/components/reglement/SponsorshipTermsContent";
import { useSponsorshipTerms } from "@/features/sponsorship/hooks/useSponsorshipTerms";
import { deriveBareme } from "@/features/sponsorship/utils/deriveBareme";
import { P } from "@/shared/ui/typographies/paragraph";

type CguModalProps = { isOpen: boolean, onClose: () => void };

// Règlement + barème servis exclusivement par l'API (aucun contenu embarqué).
export const CguModal = ({ isOpen, onClose }: CguModalProps) => {
  const { term, isLoading } = useSponsorshipTerms({ enabled: isOpen });

  return (
    <Modal dismissible show={isOpen} onClose={onClose} size="2xl">
      <ModalHeader>
        Conditions générales — Programme Yeati Blue
      </ModalHeader>
      <ModalBody>
        {term
          ? (
            <>
              <BaremeSummary bareme={deriveBareme(term)} />
              <SponsorshipTermsContent bodyHtml={term.body_html} />
            </>
          )
          : (
            <P className="text-gray-600 dark:text-gray-400">
              {isLoading
                ? "Chargement du règlement…"
                : "Le règlement n'est pas encore disponible."}
            </P>
          )}
      </ModalBody>
    </Modal>
  );
};

CguModal.displayName = "CguModal";
